'use strict';

var _ = require('lodash');
var Core = require('../core');
var Resource = require('./Resource');

module.exports = ResourceFactory;

var DataStore;
var Syncify = Core.Syncify;
var Util = Core.Util;
var Validate = Core.Validate;

function ResourceFactory (DS) {

  if (ResourceFactory.$$instance) {
    return ResourceFactory.$$instance;
  }

  DataStore = DS;
  ResourceFactory.$$instance = this;
}

ResourceFactory.$$instance = null;

ResourceFactory.prototype = {

  $resources: {},

  createResource: function (options) {
    var name;
    var resource;

    name = options.name;
    resource = this.$resources[name];

    if (!resource) {

      // ensure options exist
      Validate.exists(options, 'apiBaseUri');
      Validate.exists(options, 'definition.format');

      resource = new Resource(DataStore, options);
      this.$initCollectionSyncListeners(options);

      // cache the resource instance
      this.$resources[name] = resource;
    }

    return resource;
  },

  destroyResource: function (name) {

    if (!name) {
      throw new Error('Cannot destroy resource. Missing parameter `name`');
    }

    delete this.$resources[name];
    delete DataStore.store[name];
    Syncify.removeAllResourceSyncListeners(name);
  },

  /**
   * Initializes the resource collection sync listeners
   */
  $initCollectionSyncListeners: function (options) {
    var triggers;

    if (options.syncTriggers && options.syncTriggers.collection) {
      var triggerDefinitions = options.syncTriggers.collection;

      if (Array.isArray(triggerDefinitions)) {
        triggers = _.reduce(triggerDefinitions, function (triggers, def) {
          return triggers.concat(Util.formatDefinition(def, options));
        }, []);
      } else {

        // replace any placeholders, for example `:siteId` with the actual value from options
        triggers = Util.formatDefinition(triggerDefinitions, options);
      }

      Syncify.addSyncListeners(options.name, triggers, this.$sync.bind(this, options.name));
    }
  },

  /**
   * Callback executed when the remote a collection sync listener is triggered
   *
   * @param  {Number} timestamp
   */
  $sync: function (name, timestamp) {
    var _this = this;
    var resource = this.$resources[name];
    var lastModified = DataStore.store[name].collectionModified;

    console.info('Remote last update @ %s. Local last modified @ %s.', timestamp, lastModified);

    if (!this.$syncing && lastModified < timestamp) {

      console.info('Syncing %sResource', name);

      // set flag indicating we have started syncing
      this.$syncing = true;

      resource.findAll({timestamp: lastModified})
      .then(function () {
        _this.$syncing = false;
      });
    } else {
      console.info('%sResource does NOT need to be synced', name);
    }
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/resources/Factory.js